import { z } from 'zod'

export const assignEntityFormSchema = z.object({
  selectedUserDisplay: z.string().min(1, 'Please select a User ID'),
  email: z.string().min(1, 'Email ID is required'),
  businessRole: z.string().min(1, 'Business role is required'),
  selectedCountries: z
    .array(z.string())
    .min(1, 'Please select at least one country'),
  selectedEntityUuids: z
    .array(z.string())
    .min(1, 'Please select at least one entity'),
  selectedTanUuids: z
    .array(z.string())
    .min(1, 'Please select at least one tax identification number'),
})

export type AssignEntityFormData = z.infer<typeof assignEntityFormSchema>
